import instance from "./instance.js";
import { base } from "./config.js";
import { message } from "antd";
import qs from "qs";

/**
 * 获取任务列表
 * @param {Object} parm 请求参数
 * @param {Number} parm.per_page 每页数量
 * @param {Number} parm.page 当前页码
 * @param {String} parm.media_id 媒资id
 * @param {String} parm.create_start 创建开始时间
 * @param {String} parm.create_end 创建结束时间
 * @param {String} parm.execution_start 执行开始时间
 * @param {String} parm.execution_end 执行结束时间
 * @param {String} parm.status 	不传默认全部；1执行中；2完成
 * @returns
 */
export const GET_TASK_LIST = async (parm) =>
  await instance.post(`${base}/api/task/index`, parm);

/**
 * 获取用户详情
 * @param {Object} parm 请求参数
 * @param {Number} parm.id 用户ID
 * @returns
 */
export const GET_USER_DETAIL = async () =>
  await instance.get(`${base}/api/admin/user/detail`);

/**
 * 上传任务
 * @param {Object} parm 请求参数
 * @param {Number} parm.media_id 媒资ID
 * @returns
 */
export const SET_TASK = async (parm) =>
  await instance.post(`${base}/api/task/save`, parm);
